import { render, staticRenderFns } from "./CalendarEventSettingsDialog.vue?vue&type=template&id=b85bad8c&scoped=true&lang=pug&"
import script from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventSettingsDialog.vue?vue&type=style&index=0&id=b85bad8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85bad8c",
  null
  
)

export default component.exports